/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".product-img[_ngcontent-%COMP%]{height:220px;max-width:100%}@media (min-width:992px){.product-img[_ngcontent-%COMP%]{height:240px}}.kit-serie[_ngcontent-%COMP%]{font-size:18px;line-height:18px;margin-bottom:0}.kit-name[_ngcontent-%COMP%]{font-size:30px;line-height:30px;margin-bottom:25px}.info-diameters[_ngcontent-%COMP%]{font-size:17px;line-height:20px;margin:0}.info-diameters[_ngcontent-%COMP%]:first-of-type{margin-top:20px}.product-description[_ngcontent-%COMP%]{margin-top:15px;font-size:15px;line-height:20px;max-height:65px}"];
export { styles as styles };
